var InlineMessageIconEnum;
(function (InlineMessageIconEnum) {
    InlineMessageIconEnum["information"] = "information-circle";
    InlineMessageIconEnum["incorrect"] = "incorrect";
    InlineMessageIconEnum["warning"] = "warning-triangle";
    InlineMessageIconEnum["checkmark"] = "checkmark-circle";
})(InlineMessageIconEnum || (InlineMessageIconEnum = {}));
export default InlineMessageIconEnum;
//# sourceMappingURL=InlineMessageIconEnum.js.map